/**
 * Component: Free Gift script
 * ------------------------------------------------------------------------------
 * A snippet to display the cart value required to receive a free gift
 *
 * @namespace freeGift
 */
import * as cart from '@shopify/theme-cart';
import Cookies from 'js-cookie';

import {
  formatMoney
} from '@shopify/theme-currency';
import axios from 'axios';

/**
 * DOM selectors.
 */
const selectors = {
  message: '[js-free-gift="message"]',
};

/**
 * Create a new gift with purchase object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    message: [...document.querySelectorAll(selectors.message)],
  };

  /**
   * Initialise component.
   */
  function init() {
    if (theme.features.freeGift) {
      setEventBusListeners();

      /* console.log('before');
      axios.get(`/cart.js?no-cache=${new Date().getTime()}`)
      .then((response) => {
        response.data.freeGiftAdded = true;
        update(response)
      })
      .catch((error) => { throw new Error(error); }); */
    }
  }

  /**
   * Set listeners to update on every cart change.
   */
  function setEventBusListeners() {
    Frame.EventBus.listen('AjaxCart:updated', (response) => update(response));
  }

  /**
   * Update gift with purchase notification.
   * @param {Object} cartData - Cart Data.
   */
  function update(cartData) {
    console.log(cartData);
    if (cartData.freeGiftAdded) {
      return;
    }

    render(cartData.total_price);
    handleGift(cartData, cartData.total_price);

    if (theme.features.currencyConverter) {
      Frame.EventBus.emit('Currency:convertAll');
    }
  }

  /**
   * Update notification template using new values.
   * @param {Number} total - Current cart total.
   */
  function render(total) {
    const minValue1 = theme.freeGift.minValue1;
    const minValue3 = getMinValue3();
    const messages = theme.freeGift.messages;

    if (total > 0) {
      if (total < minValue1) {
        /**
         * Message shown when customer has not spent enough to
         * earn the first gift
         */
        nodeSelectors.message.forEach((element) => {
          element.innerHTML = messages.blank;
        });
      } else if (total >= minValue1 && minValue3 && total >= minValue3) {
        /**
         * Message shown when customer has earned the first gift
         * but has not yet spent enough for a second
         */
        nodeSelectors.message.forEach((element) => {
          element.innerHTML = messages.third_ideal;
        });
      } else {
        /**
         * Message shown when customer has not spent anything
         */
        nodeSelectors.message.forEach((element) => {
          element.innerHTML = messages.initial_partial;
        });
      }
    }
  }


  /**
   * Checks if a minValue for the second gift exists and assigns its value
   * @returns second gifts minValue
   */
  function getMinValue2() {
    let minValue2;

    if (theme.freeGift2) {
      minValue2 = theme.freeGift2.minValue2;
    }

    return minValue2;
  }

  /**
   * Checks if a minValue for the second gift exists and assigns its value
   * @returns second gifts minValue
   */
  function getMinValue3() {
    let minValue3;

    if (theme.freeGift3) {
      minValue3 = theme.freeGift3.minValue3;
    }

    return minValue3;
  }

  /**
   * Checks whether a gift should be added or removed from the cart
   * @param {Object} cartData - cart data
   */
  function handleGift(cartData, totalPrice) {
    const total = totalPrice;
    const minValue1 = theme.freeGift.minValue1;
    const minValue2 = getMinValue2();
    const minValue3 = getMinValue3();
    const giftsToAdd = [];

    console.log('handleGift');
    const giftLineItemsInCart = checkGiftsInCart(cartData);
    if (total <= 0 || total < minValue1) {
      if (giftLineItemsInCart.length) {
        removeGifts(giftLineItemsInCart);
      }
      return;
    }
    console.log(checkGiftsInCart(cartData))
    if (giftLineItemsInCart.length > 0) {
      const quantityOfFirstItem = giftLineItemsInCart[0].quantity;
      console.log('Quantità del primo elemento:', quantityOfFirstItem);
    } else {
      console.log('Nessun elemento trovato in giftLineItemsInCart');
    }
    if (total >= minValue1 && total < minValue2 && total < minValue3) {
      giftsToAdd.push(1);
      console.log('primo regalo')
    } else {
      removeGift(cartData, 1);
    }
    if (total >= minValue2 && total < minValue3) {
      giftsToAdd.push(2);
      console.log('secondo regalo')
    } else {
      removeGift(cartData, 2);
    }
    if (total >= minValue3) {
      giftsToAdd.push(3);
      console.log('terzo regalo')
    } else {
      removeGift(cartData, 3);
    }
    console.log(giftsToAdd)
    addGifts(cartData, giftsToAdd);
  }

  /**
   * Checks how many gifts are present in the cart
   * @param {Object} cartData - cart data
   * @returns {Array} - array of gift line items in the cart.
   */
  function checkGiftsInCart(cartData) {
    const giftsInCart = [];
    const gift1LineItem = checkGiftAdded(cartData, 1);
    const gift2LineItem = checkGiftAdded(cartData, 2);
    const gift3LineItem = checkGiftAdded(cartData, 3);

    if (gift1LineItem) {
      giftsInCart.push(gift1LineItem);
    }

    if (gift2LineItem) {
      giftsInCart.push(gift2LineItem);
    }
    if (gift3LineItem) {
      giftsInCart.push(gift3LineItem);
    }
    console.log(giftsInCart)

    return giftsInCart;
  }

  /**
   * Add multiple gifts to the cart at once.
   * @param {Object} cartData - cart data
   * @param {Array} giftsToAdd - Array of gifts to add to the cart
   */
  function addGifts(cartData, giftsToAdd) {
    const filteredGiftsToAdd = giftsToAdd.filter((gift) => {
      return !checkGiftAdded(cartData, gift);
    });

    if (!filteredGiftsToAdd.length) {
      return;
    }
    console.log('filteredGiftsToAdd' + filteredGiftsToAdd.length)

    const addItemsArray = filteredGiftsToAdd.map((gift) => {
      const giftId = getItemId(gift);
      const giftQty = getGiftQty(gift);
      console.log('qty' + giftQty)

      return {
        id: giftId,
        quantity: giftQty,
        properties: {
          'Free Gift': 'Yes',
          '_gift-product': gift,
        },
      };
    });
    console.log('addItemsArray' + addItemsArray)

    axios.post('/cart/add.js', {
        items: addItemsArray
      })
      .then((addResponses) => {
        Frame.EventBus.emit('AjaxCart:freeGiftAdded', addResponses[addResponses.length - 1]);
        return addResponses;
      })
      .catch((error) => {
        throw new Error('Could not add gifts to the cart', error);
      });
  }

  /**
   * Removes the gift passed in as a param if it is present in the cart
   * @param {Object} cartData - cart data
   * @param {Number} gift
   * @returns response
   */
  function removeGift(cartData, gift) {
    try {
      const giftLineItem = checkGiftAdded(cartData, gift);

      if (!giftLineItem) {
        return;
      }

      const cartLineItemElement = document.querySelector(`.ajax-cart__line-item[data-key="${giftLineItem.key}"]`);

      Frame.EventBus.emit(
        'AjaxCart:removingItem',
        cartLineItemElement,
      );

      cart.removeItem(giftLineItem.key)
        .then((response) => {
          Frame.EventBus.emit('AjaxCart:itemRemoved', response);
          return response;
        }).catch(() => {
          throw new Error('could not remove gift from cart');
        });
    } catch (error) {
      throw new Error('Could not check if gift is in cart', error);
    }
  }

  /**
   * Remove multiple line items from the cart.
   * @param {Array} lineItemsToRemove - Array of line item objects to remove
   */
  function removeGifts(lineItemsToRemove) {
    const removeRequests = lineItemsToRemove
      .map((lineItem) => {
        const cartLineItemElement = document.querySelector(`.ajax-cart__line-item[data-key="${lineItem.key}"]`);
        Frame.EventBus.emit('AjaxCart:removingItem', cartLineItemElement);
        return cart.removeItem(lineItem.key);
      });

    Promise.all(removeRequests)
      .then((removeResponses) => {
        Frame.EventBus.emit('AjaxCart:itemRemoved', removeResponses[removeResponses.length - 1]);
        return removeResponses;
      })
      .catch((error) => {
        throw new Error('Could not remove gift from cart', error);
      });
  }

  /**
   * Gets the quantity based on item number
   * @param {Number} gift
   * @returns Number item qty
   */
  function getGiftQty(gift) {
    switch (gift) {
      case 1:
        return theme.freeGift.itemQty1;
      case 2:
        return theme.freeGift2.itemQty2;
      case 3:
        return theme.freeGift3.itemQt3;
      default:
        return theme.freeGift.itemQty1;
    }
  }

  /**
   * Checks if the gift passed in as a param is present in the cart
   * @param {Object} cartData - cart data
   * @param {Number} gift
   * @returns {Object} line item
   */
  function checkGiftAdded(cartData, gift) {
    let giftId;

    if (gift === 2) {
      giftId = theme.freeGift2.itemId2;
    } else if (gift === 3) {
      giftId = theme.freeGift3.itemId3;
    } else {
      giftId = theme.freeGift.itemId1;
    }

    return cartData.items.find((item) => {
      const matchingVariantId = (item.variant_id === giftId);
      const hasGiftProperty = (item.properties && (item.properties['_gift-product'] === gift));


      return matchingVariantId && hasGiftProperty;
    });
  }


  /**
   * Get free gift id value.
   * @returns {Number}
   */
  function getItemId(gift) {
    if (gift === 3) {
      return theme.freeGift3.itemId3;
    } else if (gift === 2) {
      return theme.freeGift2.itemId2;
    } else {
      return theme.freeGift.itemId1;
    }
  }

  /**
   * Validate that gift quantities are correct.
   * - Check the gift quantities are correct.
   * - Update cart and refresh page if either gift needs updating.
   */
  function validateCheckoutCart() {
    cart.getState()
      .then((cartData) => {
        const productsTable = document.querySelector('[data-order-summary-section="line-items"]');
        const gifts1InCheckout = productsTable.querySelectorAll(`.product[data-variant-id="${theme.freeGift.itemId1}"]`);
        const gifts2InCheckout = productsTable.querySelectorAll(`.product[data-variant-id="${theme.freeGift2.itemId2}"]`);
        const gifts3InCheckout = productsTable.querySelectorAll(`.product[data-variant-id="${theme.freeGift3.itemId3}"]`);
        let totalPrice = document.querySelector('[data-checkout-subtotal-price-target]');
        if(totalPrice) {
          totalPrice = parseInt(totalPrice.getAttribute('data-checkout-subtotal-price-target'));
        }

        if (totalPrice && theme.freeGift.minValue1 && theme.freeGift2.minValue2 && theme.freeGift3.minValue3) {
          const threshold1 = theme.freeGift.minValue1;
          const threshold2 = theme.freeGift2.minValue2;
          const threshold3 = theme.freeGift3.minValue3;

          // Oltre soglia 1
          if (totalPrice >= threshold1 && totalPrice < threshold2) {
            if (!gifts1InCheckout.length) {
                axios.post('/cart/add.js', {
                  items: [{
                    id: theme.freeGift.itemId1,
                    quantity: theme.freeGift.itemQty1,
                    properties: {
                      'Free Gift': 'Yes',
                      '_gift-product': 1,
                    },
                  }]
                })
                .then((addResponses) => {
                  if(!Cookies.get('checkout_reloaded')) {
                    window.location.reload();
                    Cookies.set('checkout_reloaded', 'true', {expires: 1});
                  }

                  return;
                })
                .catch((error) => {
                  throw new Error('Could not add gifts to the cart', error);
                });
            }
          } else if (totalPrice >= threshold2 && totalPrice < threshold3) { // Oltre soglia 2 entro soglia 3
            if (!gifts2InCheckout.length) {
              axios.post('/cart/add.js', {
                items: [{
                  id: theme.freeGift2.itemId2,
                  quantity: 1,
                  properties: {
                    'Free Gift': 'Yes',
                    '_gift-product': 2,
                  },
                }]
              })
              .then((addResponses) => {
                if(!Cookies.get('checkout_reloaded')) {
                  window.location.reload();
                  Cookies.set('checkout_reloaded', 'true', {expires: 1});
                }
                return;
              })
              .catch((error) => {
                throw new Error('Could not add gifts to the cart', error);
              });
            }
          } else if (totalPrice >= threshold3) { // Oltre soglia 3
            if (!gifts3InCheckout.length) {
              axios.post('/cart/add.js', {
                items: [{
                  id: theme.freeGift3.itemId3,
                  quantity: 1,
                  properties: {
                    'Free Gift': 'Yes',
                    '_gift-product': 3,
                  },
                }]
              })
              .then((addResponses) => {
                if(!Cookies.get('checkout_reloaded')) {
                  window.location.reload();
                  Cookies.set('checkout_reloaded', 'true', {expires: 1});
                }
                return;
              })
              .catch((error) => {
                throw new Error('Could not add gifts to the cart', error);
              });
            }
          }
        }

        /* if (!gifts1InCheckout.length && !gifts2InCheckout.length && !gifts3InCheckout.length) {
          return;
        }
 */
        /* const lineItemsToUpdate = [];

        if (gift1LineItem && gift1LineItem.quantity > theme.freeGift.itemQty1) {
          lineItemsToUpdate.push({
            key: gift1LineItem.key,
            quantity: theme.freeGift.itemQty1,
          });
        }

        if (gift2LineItem && gift2LineItem.quantity > theme.freeGift2.itemQty2) {
          lineItemsToUpdate.push({
            key: gift2LineItem.key,
            quantity: theme.freeGift2.itemQty2,
          });
        }

        if (gift3LineItem && gift3LineItem.quantity > theme.freeGift3.itemQty3) {
          lineItemsToUpdate.push({
            key: gift3LineItem.key,
            quantity: theme.freeGift3.itemQty3,
          });
        }

        if (lineItemsToUpdate.length) {
          updateGiftLineItems(lineItemsToUpdate);
        } */
      })
      .catch((error) => {
        throw new Error('Could not get cart data', error);
      });
  }

  /**
   * Update gift line items.
   * - Reloads the page once request is finished.
   */
  function updateGiftLineItems(lineItemsToUpdate) {
    const updateRequests = lineItemsToUpdate.map((item) => {
      return cart.updateItem(item.key, {
        quantity: item.quantity
      });
    });

    Promise.all(updateRequests)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        throw new Error('Could not update gift line items', error);
      });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
    validateCheckoutCart,
  });
};
